import { a as _slicedToArray, e as _extends } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { u as useComponentWidth } from './useComponentWidth-dbdc6efa.js';
import { u as usePrevious } from './usePrevious-edd83563.js';
import { P as PropertyCard, a as alternativeOffersLabelsShape } from './index-4e1cd670.js';
import Title from './Title.js';
import EmptySectionMessage from './EmptySectionMessage.js';
import { e as multiPropertyOfferShape, c as currencyShape, g as feedbackMessagesShape, f as formattedSearchParamsShape, h as trustYouReducerShape, n as nodeOrStringProp } from './PropTypes-e1e509ba.js';
import './Card-003e3c50.js';
import './Image.js';
import './Modal.js';
import 'react-dom';
import './ModalHeader-77a50105.js';
import './index-11bc5ac3.js';
import './_commonjsHelpers-17042db9.js';
import './tslib.es6-2748fcb6.js';
import 'moment';
import './MapView.js';
import './Location.js';
import './AmenitiesList.js';
import './Description.js';
import './Price.js';
import './index-f48c5efa.js';
import './useIntl-2a91ee7b.js';
import './injectIntl-d3879c1a.js';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';
import './provider-936ecd10.js';
import './Label.js';
import './Button-a16585e5.js';
import './utilsHelpers-e4b21f4b.js';
import './LoadingBlock.js';
import './PropertyRating.js';
import './LoadingSpinner.js';
import './handleOpenLink-49ba3691.js';
import './Divider.js';

function PropertiesList(props) {
  var _usePrevious;
  var availableProperties = props.availableProperties,
    notAvailableProperties = props.notAvailableProperties,
    className = props.className,
    displayMode = props.displayMode,
    alternativeGrid = props.alternativeGrid,
    isLoading = props.isLoading,
    showFeedbackMessage = props.showFeedbackMessage,
    propertyCardProps = props.propertyCardProps,
    params = props.params,
    domain = props.domain,
    getQueryString = props.getQueryString,
    feedbackMessages = props.feedbackMessages,
    onClick = props.onClick,
    styledPrice = props.styledPrice,
    priceMessages = props.priceMessages,
    onPropertiesRendered = props.onPropertiesRendered,
    userCountry = props.userCountry,
    trustYou = props.trustYou,
    isQA = props.isQA,
    hidePrices = props.hidePrices,
    hidePricesMessage = props.hidePricesMessage,
    alternativeOffersLabels = props.alternativeOffersLabels,
    intl = props.intl;
  var previousLength = ((_usePrevious = usePrevious(availableProperties)) === null || _usePrevious === void 0 ? void 0 : _usePrevious.length) || 0;
  var getColumnsNumberByDisplayMode = useCallback(function () {
    return displayMode === 'list' ? 1 : 3;
  }, [displayMode]);
  var _useComponentWidth = useComponentWidth(),
    _useComponentWidth2 = _slicedToArray(_useComponentWidth, 2),
    rootRef = _useComponentWidth2[0],
    rootWidth = _useComponentWidth2[1];
  var getColumnsNumberByResize = useCallback(function () {
    if (rootRef.current && displayMode === 'grid') {
      if (rootWidth >= 900) {
        return 3;
      }
      if (rootWidth < 900 && rootWidth >= 768) {
        return 2;
      }
      if (rootWidth < 768) {
        return 1;
      }
    }
    return 1;
  }, [displayMode, rootRef, rootWidth]);
  var _useState = useState(getColumnsNumberByDisplayMode),
    _useState2 = _slicedToArray(_useState, 2),
    propertiesListColumns = _useState2[0],
    setPropertiesListColumns = _useState2[1];
  useEffect(function () {
    var shouldRun = onPropertiesRendered && (availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length) && previousLength !== availableProperties.length;
    if (shouldRun) {
      onPropertiesRendered('Hotel List', availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length);
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [availableProperties]);
  useEffect(function () {
    return setPropertiesListColumns(getColumnsNumberByDisplayMode);
  }, [displayMode, getColumnsNumberByDisplayMode]);
  useEffect(function () {
    return setPropertiesListColumns(getColumnsNumberByResize);
  }, [rootWidth, getColumnsNumberByResize]);
  var availablePropertiesExist = !isLoading && (availableProperties === null || availableProperties === void 0 ? void 0 : availableProperties.length) > 0;
  var notAvailablePropertiesExist = !isLoading && (notAvailableProperties === null || notAvailableProperties === void 0 ? void 0 : notAvailableProperties.length) > 0;
  var noOfferTypeAvailable = !availablePropertiesExist && !notAvailablePropertiesExist;
  var showNoAvailableOffersMessage = !isLoading && (!availablePropertiesExist && notAvailablePropertiesExist || noOfferTypeAvailable) && showFeedbackMessage && feedbackMessages.noAvailableOffersMessage;
  function renderLoadingPropertyCards(cardsAmount) {
    var cards = [];
    for (var i = 0; i < cardsAmount; i++) {
      cards.push(/*#__PURE__*/React__default.createElement(PropertyCard, {
        key: i.toString(),
        name: "Lorem ipsum",
        code: "Lorem ipsum ".concat(i),
        description: "Lorem ipsum",
        isLoading: true,
        displayMode: displayMode,
        alternativeGridMode: alternativeGrid,
        userCountry: userCountry,
        intl: intl
      }));
    }
    return cards;
  }
  var getTrustYouProfileById = function getTrustYouProfileById(id) {
    var _trustYou$id, _trustYou$id$profile;
    return id && ((_trustYou$id = trustYou[id]) === null || _trustYou$id === void 0 ? void 0 : (_trustYou$id$profile = _trustYou$id.profile) === null || _trustYou$id$profile === void 0 ? void 0 : _trustYou$id$profile.data);
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "bf-properties-list\n                display-as-".concat(displayMode, "\n                display-with-").concat(propertiesListColumns, "-columns\n                ").concat(className, "\n            "),
    ref: rootRef
  }, isLoading ? renderLoadingPropertyCards(displayMode === 'list' ? 3 : 6) : null, availablePropertiesExist ? availableProperties.map(function (property) {
    var key = "PROPERTY_".concat(property.code);
    return /*#__PURE__*/React__default.createElement(PropertyCard, _extends({
      key: key
    }, propertyCardProps, property, {
      displayMode: displayMode,
      alternativeGridMode: alternativeGrid,
      onClick: onClick,
      params: params,
      domain: domain,
      getQueryString: getQueryString,
      trustYouProfile: getTrustYouProfileById(property.trustYouId),
      buttonMessage: feedbackMessages.buttonMessage,
      styledPrice: styledPrice,
      priceMessages: priceMessages,
      reviewsCountMessage: feedbackMessages.reviewsCountMessage,
      reviewsModalTitleMessage: feedbackMessages.reviewsModalTitleMessage,
      userCountry: userCountry,
      isQA: isQA,
      hidePrices: hidePrices,
      hidePricesMessage: hidePricesMessage,
      alternativeOffersLabels: alternativeOffersLabels,
      intl: intl
    }));
  }) : null, showNoAvailableOffersMessage ? /*#__PURE__*/React__default.createElement(EmptySectionMessage, {
    content: feedbackMessages.noAvailableOffersMessage,
    className: "bf-properties-list-full-width-element bf-properties-list-no-availability-message"
  }) : null, notAvailablePropertiesExist ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Title, {
    content: feedbackMessages.notAvailablePropertiesTitleMessage,
    size: "medium",
    className: "bf-properties-list-full-width-element bf-properties-list-no-available-properties-title"
  }), notAvailableProperties.map(function (property) {
    var key = "PROPERTY_".concat(property.code);
    return /*#__PURE__*/React__default.createElement(PropertyCard, _extends({
      key: key
    }, propertyCardProps, property, {
      displayMode: displayMode,
      alternativeGridMode: alternativeGrid,
      params: params,
      onClick: onClick,
      domain: domain,
      isNotAvailable: true,
      getQueryString: getQueryString,
      trustYouProfile: getTrustYouProfileById(property.trustYouId),
      buttonMessage: feedbackMessages.buttonMessage,
      reviewsCountMessage: feedbackMessages.reviewsCountMessage,
      reviewsModalTitleMessage: feedbackMessages.reviewsModalTitleMessage,
      userCountry: userCountry,
      isQA: isQA,
      intl: intl
    }));
  })) : null);
}
PropertiesList.defaultProps = {
  availableProperties: [],
  notAvailableProperties: [],
  className: '',
  displayMode: 'list',
  alternativeGrid: false,
  isLoading: false,
  showFeedbackMessage: false,
  domain: '',
  params: {},
  getQueryString: function getQueryString() {},
  onClick: function onClick() {},
  onPropertiesRendered: null,
  trustYou: null,
  styledPrice: false,
  isQA: false,
  hidePrices: false,
  hidePricesMessage: null
};
PropertiesList.propTypes = {
  /**
  Array of available properties
   */
  availableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  /**
  Array of not available properties
   */
  notAvailableProperties: PropTypes.arrayOf(PropTypes.shape(multiPropertyOfferShape)),
  /**
  Custom className
   */
  className: PropTypes.string,
  /**
  Show properties in list, grid or map mode
   */
  displayMode: PropTypes.oneOf(['list', 'grid', 'map']),
  /**
  Specifies if alternative grid view should be shown instead of Booking Flow grid view
   */
  alternativeGrid: PropTypes.bool,
  /**
  Config props to propertyCard
   */
  propertyCardProps: PropTypes.shape({
    currency: PropTypes.shape(currencyShape).isRequired,
    currencyDisplay: PropTypes.string.isRequired,
    mapProvider: PropTypes.elementType.isRequired
  }).isRequired,
  /**
  Property in loading state
   */
  isLoading: PropTypes.bool,
  /**
  Allows to show feedback Message
   */
  showFeedbackMessage: PropTypes.bool,
  /**
  Intl feedback messages
   */
  feedbackMessages: PropTypes.shape(feedbackMessagesShape).isRequired,
  /**
  Site domain
   */
  domain: PropTypes.string,
  /**
  Url params
   */
  params: PropTypes.shape(formattedSearchParamsShape),
  /**
  Function helper to get the redirect url
   */
  getQueryString: PropTypes.func,
  /**
  Function triggered on property selection
   */
  onClick: PropTypes.func,
  /**
   * The property list can run a function, passing it the number of available rendered hotels
   */
  onPropertiesRendered: PropTypes.func,
  /**
  Dictionary of trustYou profiles and reviews
   */
  trustYou: PropTypes.objectOf(PropTypes.shape(trustYouReducerShape)),
  /**
  Show the price styled (currency, integer, decimal)
   */
  styledPrice: PropTypes.bool,
  /**
  Show the price messages
   */
  priceMessages: PropTypes.shape({
    startingFrom: nodeOrStringProp,
    priceDisplayMode: nodeOrStringProp
  }).isRequired,
  userCountry: PropTypes.string.isRequired,
  /**
   * This value is used for data-test-id
   */
  isQA: PropTypes.bool,
  hidePrices: PropTypes.bool,
  hidePricesMessage: PropTypes.node,
  alternativeOffersLabels: alternativeOffersLabelsShape.isRequired,
  intl: PropTypes.object.isRequired
};

export default PropertiesList;
//# sourceMappingURL=PropertiesList.js.map
